import { Link } from "react-router-dom";
import { TrendingDown } from "lucide-react";
import { fmtMoney, safeImg } from "@/lib/api";

const DAYS = 14;
export const isRecentDrop = (i) =>
  i.price_dropped_at && i.previous_price != null && !i.bought && Date.now() - new Date(i.price_dropped_at).getTime() < DAYS * 86400000;

export const PriceDrops = ({ shops }) => {
  const drops = shops.filter((s) => s.kind === "wishlist").flatMap((s) => s.items.filter(isRecentDrop).map((i) => ({ ...i, list: s.name })));
  if (!drops.length) return null;
  return (
    <div data-testid="price-drops" className="mb-8 rounded-2xl border border-t-c2-line bg-t-c2-soft/60 p-5 sm:p-6 fade-up">
      <div className="flex items-center gap-3 mb-4">
        <div className="h-10 w-10 rounded-xl bg-t-c2 text-white flex items-center justify-center"><TrendingDown className="h-5 w-5" /></div>
        <div className="flex-1">
          <p className="font-serif-display text-2xl font-semibold leading-tight">Prices dropped</p>
          <p className="text-sm text-t-muted">Good news from your wishlists.</p>
        </div>
        <Link to="/lists?tab=wishlist" data-testid="price-drops-view" className="text-xs font-medium text-t-primary hover:underline">View wishlists</Link>
      </div>
      <ul className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {drops.slice(0, 6).map((d) => (
          <li key={d.id} data-testid={`price-drop-${d.id}`} className="flex items-center gap-3 bg-t-card rounded-xl px-3 py-2.5 border border-t-line">
            {d.image_url && <img src={safeImg(d.image_url)} alt="" className="h-9 w-9 rounded-lg object-cover" onError={(e) => (e.currentTarget.style.display = "none")} />}
            <span className="flex-1 min-w-0">
              <span className="block text-sm truncate">{d.name}</span>
              <span className="block text-[11px] text-t-muted">{d.list}</span>
            </span>
            <span className="text-xs text-t-faint line-through">{fmtMoney(d.previous_price)}</span>
            <span className="text-sm font-semibold text-t-c2-ink">{fmtMoney(d.price)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
